/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import LeadPreview from 'DesignSystem/LeadPreview/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Detail/Content",
  handleClose,
  onClickNextAction,
  onClickPrevAction,
  prevActionDisabled,
  nextActionDisabled
  
}) {
let selectedLeadIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.id',
})
  return (<React.Fragment
>
<LeadPreview
  viewPath={`${viewPath}/LeadPreview`}
 data="selected.lead.id"
 leadId={selectedLeadIdValueData}
 showNextActions={true}
 handleClose={handleClose}
 onClickNextAction={onClickNextAction}
 onClickPrevAction={onClickPrevAction}
 prevActionDisabled={prevActionDisabled}
 nextActionDisabled={nextActionDisabled}
/>
{children}
</React.Fragment>)
}